import { Autocomplete, TextField } from "@mui/material";
import { generatePkLabel, PrimaryKeyDt } from "../../collectionLongForm/widgets/ForeignKeyField";
import { FunctionComponent, useContext } from "react";
import { FormEntryContext } from "components/collectionsForm";
import {minTableColumnWidth} from './const'

interface ForeignKeyFieldProps{
    defaultValue: string;
    onChange: (value: string)=>void;
    required: boolean;
}

export const ForeignKeyField: FunctionComponent<ForeignKeyFieldProps> = ({
    defaultValue,
    required,
    onChange
}) => {

    const schemaContext = useContext(FormEntryContext)

    // console.log(props.formData);
    // console.log(props.state);
    // console.log();
    return (
            <Autocomplete
                style={{minWidth: minTableColumnWidth}}
                options={schemaContext?.primaryKeys ?? []}
                isOptionEqualToValue={(option: PrimaryKeyDt, value) => option.nativeStr === value.nativeStr}
                getOptionLabel={generatePkLabel}
                disabled={!schemaContext}
                defaultValue={schemaContext?.primaryKeys.find((pk) => pk.nativeStr === defaultValue) ?? undefined}

                onChange={(_event, value) => onChange(value?.nativeStr ?? "")}
                renderInput={(params) => <TextField
                    {...params}
                    type='text'
                    required={required}
                />}
            />
    );
};